module.exports = __webpack_public_path__ + "static/img/menPort.0aa2482.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/menPort.jpg
// module id = hE2e
// module chunks = 0